import { ref, computed } from 'vue';

// 1. Definimos las variables a nivel de módulo (esto las vuelve un estado global/singleton)
const items = ref(JSON.parse(localStorage.getItem('cart')) || []);
const isOpen = ref(false);

export function useCart() {
  const saveCart = () => {
    localStorage.setItem('cart', JSON.stringify(items.value));
  };

// cartStore.js
const addToCart = (product) => {
  console.log("Producto recibido en el store:", product); // <-- Revisa esto en F12
  
  if (!product || !product.id) {
    console.error("El producto recibido no tiene un 'id' válido:", product);
    return;
  }

  const existing = items.value.find(i => i.id === product.id);
  if (existing) {
    existing.quantity++;
  } else {
    items.value.push({ ...product, quantity: 1 });
  }
  
  isOpen.value = true; // Abre automáticamente el carrito
  saveCart();
};

  const removeItem = (id) => {
    items.value = items.value.filter(i => i.id !== id);
    saveCart();
  };

  const updateQuantity = (id, delta) => {
    const item = items.value.find(i => i.id === id);
    if (item) {
      item.quantity += delta;
      if (item.quantity <= 0) {
        removeItem(id);
      } else {
        saveCart();
      }
    }
  };

  const toggleCart = () => {
    isOpen.value = !isOpen.value;
  };

  const total = computed(() => 
    items.value.reduce((sum, item) => sum + item.price * item.quantity, 0)
  );

  const itemCount = computed(() => 
    items.value.reduce((sum, item) => sum + item.quantity, 0)
  );

  return {
    items,
    isOpen,
    total,
    itemCount,
    addToCart,
    removeItem,
    updateQuantity,
    toggleCart
  };
}